import { createAsyncThunk } from "@reduxjs/toolkit"
import { branchProductsUnit, documentListUnit, kitchenBranchUnit, kitchenProductsUnit, salesManBranchUnit } from "../units/supplyGetUnits"
import { branchCreateUnit, branchDetailUnit, branchToogleArchiveUnit, branchUpdateUnit } from "../units/branchUnits"



export const getBranchAction = createAsyncThunk('get/branch', async (_, {rejectWithValue}) => {
    try {
        const branch = await salesManBranchUnit()
        const documents = await documentListUnit()
        console.log({...branch, documents, branches: branch})
        return {...branch, documents, branches: branch}
    } catch(e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})


export const branchProductsAction = createAsyncThunk('/branch/products', async (_,{rejectWithValue}) => {
    try {
        const response = await branchProductsUnit()
        return response
    } catch(e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})

export const kitchenProductsAction = createAsyncThunk('/branch/products', async (id,{rejectWithValue}) => {
    try {
        const response = await kitchenProductsUnit(id)
        return response
    } catch(e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})



export const getBranchActionKitchen =  createAsyncThunk('get/branch/kitchen', async (_, {rejectWithValue}) => {
    try {
        const branches = await kitchenBranchUnit()
        const documents = await documentListUnit()
        return {branches, documents}
    } catch(e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})

export const branchDetailAction = createAsyncThunk('branch/detail', async(param,{rejectWithValue}) => {
    try {
        const response = await branchDetailUnit(param)
        return response.data
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})

export const branchToogleArchiveAction = createAsyncThunk('branch/toogle/arhcive', async(param,{rejectWithValue}) => {
    try {
        const response = await branchToogleArchiveUnit(param)
        return response.data
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})
export const branchUpdateAction = createAsyncThunk('branch/update', async(param,{rejectWithValue}) => {
    try {
        const response = await branchUpdateUnit(param)
        return response.data
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})
export const branchCreateAction = createAsyncThunk('branch/create', async(param,{rejectWithValue}) => {
    try {
        const response = await branchCreateUnit(param)
        return response.data
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})